<h3></h3>
<form [formGroup]="form" class="column gap" (ngSubmit)="onSubmit()">
  <div class="gap-sm column">

    <span>
      {{ 'welcomeVideoManagement.welcomeVideoUrlLabel' | translate }}
    </span>
    <mat-form-field
      class="welcome-video-input"
    >
      <input
        matInput
        type="text"
        formControlName="url"
        placeholder="{{ 'welcomeVideoManagement.welcomeVideoUrlPlaceholder' | translate }}">
    </mat-form-field>
  </div>
  <div class="row gap">
    <mat-slide-toggle
      labelPosition="before"
      formControlName="enabled"
    >
      {{ 'welcomeVideoManagement.enableWelcomeVideoLabel' | translate }}
    </mat-slide-toggle>
  </div>
  <button
    mat-button
    class="btn btn--primary fit-content vertical-center"
    type="submit"
    >
    {{ 'global.saveChanges' | translate }}
  </button>
</form>
